module.exports = __webpack_public_path__ + "img/nav-notification.56bd22bd.svg";